import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function AdminSubscriptions() {
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [error, setError] = useState('');

  // Plan form
  const [planId, setPlanId] = useState('basic');
  const [name, setName] = useState('Basic');
  const [priceCents, setPriceCents] = useState(0);
  const [features, setFeatures] = useState('');
  const [active, setActive] = useState(true);
  const [monthlyQuotaMinutes, setMonthlyQuotaMinutes] = useState(0);
  const [tier, setTier] = useState('free');
  const [saving, setSaving] = useState(false);

  // User assignment
  const [userId, setUserId] = useState('');
  const [assignPlanId, setAssignPlanId] = useState('');
  const [userSub, setUserSub] = useState(null);
  const [assignBusy, setAssignBusy] = useState(false);

  async function loadPlans() {
    setLoadingPlans(true);
    setError('');
    try {
      const res = await api.listPlans();
      if (res?.error) throw new Error(res.error);
      setPlans(Array.isArray(res?.items) ? res.items : []);
    } catch (e) {
      setError(e?.message || 'Failed to load plans');
    } finally {
      setLoadingPlans(false);
    }
  }

  useEffect(() => { loadPlans(); }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ color: '#ff7a45' }}>Subscriptions (Admin)</h2>
      {error && <p style={{ color: '#fca5a5' }}>{error}</p>}

      <section style={{ marginTop: 12, background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
        <h3 style={{ color: '#e5e7eb', marginTop: 0 }}>Plans</h3>
        {loadingPlans ? (
          <p>Loading…</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #374151', padding: '8px 4px' }}>Plan ID</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #374151', padding: '8px 4px' }}>Name</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #374151', padding: '8px 4px' }}>Price</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #374151', padding: '8px 4px' }}>Features</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((p) => (
                <tr key={p.planId}>
                  <td style={{ padding: '6px 4px', borderBottom: '1px solid #111827' }}>{p.planId}</td>
                  <td style={{ padding: '6px 4px', borderBottom: '1px solid #111827' }}>{p.name}</td>
                  <td style={{ padding: '6px 4px', borderBottom: '1px solid #111827' }}>${(Number(p.priceCents) / 100).toFixed(2)}</td>
                  <td style={{ padding: '6px 4px', borderBottom: '1px solid #111827' }}>{Array.isArray(p.features) ? p.features.join(', ') : ''}</td>
                </tr>
              ))}
              {plans.length === 0 && (
                <tr><td colSpan={4} style={{ color: '#9ca3af', padding: '8px 4px' }}>No plans</td></tr>
              )}
            </tbody>
          </table>
        )}
      </section>

      <section style={{ marginTop: 12, background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
        <h3 style={{ color: '#e5e7eb', marginTop: 0 }}>Create/Update Plan</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <input placeholder="Plan ID" value={planId} onChange={(e) => setPlanId(e.target.value)} style={input} />
          <input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} style={input} />
          <input placeholder="Price (cents)" type="number" value={priceCents} onChange={(e) => setPriceCents(Number(e.target.value))} style={{ ...input, width: 160 }} />
          <input placeholder="Monthly quota (minutes)" type="number" value={monthlyQuotaMinutes} onChange={(e) => setMonthlyQuotaMinutes(Number(e.target.value))} style={{ ...input, width: 220 }} />
          <select value={tier} onChange={(e) => setTier(e.target.value)} style={select}>
            <option value="anonymous">anonymous</option>
            <option value="free">free</option>
            <option value="creator">creator</option>
            <option value="pro">pro</option>
            <option value="ad">ad</option>
            <option value="enterprise">enterprise</option>
          </select>
          <label style={{ color: '#e5e7eb', display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} /> Active
          </label>
          <input placeholder="Features (comma-separated)" value={features} onChange={(e) => setFeatures(e.target.value)} style={{ ...input, minWidth: 320 }} />
          <button disabled={saving} onClick={async () => {
            setSaving(true);
            setError('');
            try {
              const payload = { planId: planId.trim(), name: name.trim(), priceCents: Number(priceCents) || 0, features: features ? features.split(',').map(s => s.trim()).filter(Boolean) : [], active, monthlyQuotaMinutes: Number(monthlyQuotaMinutes) || 0, tier };
              const res = await api.upsertPlan(payload);
              if (res?.error) throw new Error(res.error);
              await loadPlans();
            } catch (e) {
              setError(e?.message || 'Failed to save plan');
            } finally {
              setSaving(false);
            }
          }} style={btnPrimary}>{saving ? 'Saving…' : 'Save Plan'}</button>
        </div>
      </section>

      <section style={{ marginTop: 12, background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
        <h3 style={{ color: '#e5e7eb', marginTop: 0 }}>Assign Plan to User</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <input placeholder="User ID" value={userId} onChange={(e) => setUserId(e.target.value)} style={{ ...input, minWidth: 260 }} />
          <select value={assignPlanId} onChange={(e) => setAssignPlanId(e.target.value)} style={select}>
            <option value="">Select plan…</option>
            {plans.map((p) => (
              <option key={p.planId} value={p.planId}>{p.name} (${(Number(p.priceCents)/100).toFixed(2)})</option>
            ))}
          </select>
          <button disabled={assignBusy || !userId || !assignPlanId} onClick={async () => {
            setAssignBusy(true);
            setError('');
            try {
              const res = await api.assignUserSubscription(userId.trim(), assignPlanId);
              if (res?.error) throw new Error(res.error);
              setUserSub(res?.item || null);
            } catch (e) {
              setError(e?.message || 'Failed to assign plan');
            } finally {
              setAssignBusy(false);
            }
          }} style={btnPrimary}>{assignBusy ? 'Assigning…' : 'Assign'}</button>
          <button onClick={async () => {
            setError('');
            try {
              const res = await api.getUserSubscription(userId.trim());
              if (res?.error) throw new Error(res.error);
              setUserSub(res?.item || null);
            } catch (e) {
              setError(e?.message || 'Failed to fetch user subscription');
            }
          }} style={btnSecondary}>Fetch Current</button>
        </div>
        <div style={{ marginTop: 8, color: '#9ca3af' }}>
          {userSub ? (
            <div>
              <div>User: {userSub.userId}</div>
              <div>Plan: {userSub.plan ? `${userSub.plan.name} (${userSub.plan.planId})` : 'none'}</div>
              <div>Since: {userSub.since}</div>
            </div>
          ) : (
            <div>No subscription loaded</div>
          )}
        </div>
      </section>
    </div>
  );
}

const input = { background: '#0b0b0e', color: '#e5e7eb', border: '1px solid #374151', borderRadius: 8, padding: 8 };
const select = { background: '#0b0b0e', color: '#e5e7eb', border: '1px solid #374151', borderRadius: 8, padding: 8 };
const btnPrimary = { background: '#ff5a1f', color: '#fff', border: 0, borderRadius: 8, padding: '8px 12px', cursor: 'pointer' };
const btnSecondary = { background: '#374151', color: '#e5e7eb', border: 0, borderRadius: 8, padding: '8px 12px', cursor: 'pointer' };
